import React from "react";
import "./Headings.css";

export default class Paragraph extends React.Component {
  public render() {
    return <h5 className="paragraph">{this.props.children}</h5>;
  }
}
